export const API_KEY = 'fbee7941f117d258bba2ad0706e433a4';
export const BASE_URL = 'https://api.themoviedb.org/3/';
export const KEY_WATCHED = 'watched';
export const KEY_QUEUE = 'queue';
